import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import PaymentService from "services/payment";
import "paylane";
import PaymentView from "./view";

// const PayLaneClient = window.PayLaneClient;

class Payment extends Component {
  state = {
    cardNumber: "",
    name: "",
    CVV: "",
    email: "",
    address: "",
    expirationMonth: "",
    expirationYear: "",
    error: false,
    product: "standard",
  };

  componentDidMount() {
    const { history, location, user } = this.props;

    if (!user.id || user.type !== "company") history.push("/login");

    const params = new URLSearchParams(location.search);
    const product = params.get("product");

    if (product) this.setState({ product });
    /*
    try {
      const client = new PayLaneClient({
        publicApiKey: "9ad17d96ae90b6cb89f57139e14cdc4b0f493329",
        paymentForm: "checkout-form",
      });
    } catch (e) {
      console.log(e); // exceptions are fatal
    }
    */
  }

  pay = (e) => {
    const {
      cardNumber,
      name,
      CVV,
      email,
      expirationMonth,
      expirationYear,
      address,
      product,
    } = this.state;
    const companyID = this.props.user.id;

    e.preventDefault();

    PaymentService.pay({
      cardNumber,
      name,
      CVV,
      expirationMonth,
      expirationYear,
      email,
      address,
      product,
      companyID,
    }).then((res) => {
      if (res !== "success") {
        this.setState({ error: true });
        window.scrollTo(0, 0);
      } else {
        this.props.history.push("/?paymentCompleted=true");
        window.scrollTo(0, 0);
      }
    });
  };

  setFormData = (type, value) => this.setState({ [type]: value });

  render() {
    const { product, error } = this.state;
    return (
      <PaymentView
        setFormData={this.setFormData}
        pay={this.pay}
        product={product}
        error={error}
      />
    );
  }
}

const mapStateToProps = ({ post, user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Payment));
